import PropTypes from "prop-types";
import React, { useEffect, useState, Fragment } from "react";
import withRouter from "../Common/withRouter";
import { withTranslation } from "react-i18next";
import SidebarClient from "./SidebarClient";
import SidebarStaff from "./SidebarStaff";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-icon.png";
import logoDark from "../../assets/images/logo-dark.png";
import { connect, useSelector } from "react-redux";
import { createSelector } from "reselect";

const Sidebar = (props) => {

  const [infoUser, setInfoUser] = useState({ is_staff: false, is_customer_admin: false, is_customer_user: false, permissions: [] })

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, loading, data } = useSelector(LoginProperties);

  useEffect(() => {
    if(data.data){
      setInfoUser(data.data);
    }
  }, [loading, data]);

  return (
    <Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="17" />
            </span>
          </Link>
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLightPng} alt="" height="50" />
            </span>
          </Link>
        </div>
        <h4 className="text-center text-white">{ infoUser.partner_name }</h4>
        <div data-simplebar className="h-100">
          {infoUser.is_staff && (
            <SidebarStaff userPermissions={infoUser.permissions}/>
          )}
          {(infoUser.is_customer_admin || infoUser.is_customer_user) && (
            <SidebarClient userPermissions={infoUser.permissions}/>
          )}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
